import React from "react";

export const HeartIcon = (props) => (
  <span className="heart" role="img">
    {props.symbol}
  </span>
);
